<template>
  <v-row class="d-flex flex-wrap justify-space-around">
    <!-- filter -->
    <v-col cols="12" class="ma-auto">
      <OverviewFilter @changechartInfoState="changeChartInfoState" :chartInfoState="chartInfoState"
                      :chartInfo="chartInfo"/>
    </v-col>

    <!-- charts show or hide -->
    <v-col :class="{ 'd-none': getDateRange.length < 1 }">
      <v-row id="overviewContent">
        <!-- card information -->
        <v-col
          v-for="(item, index) in cardInfoItem"
          :key="index"
          cols="12"
          md="3"
          class="ma-auto"
        >
          <CardInfo :item="item" @goto="scrollToTarget" />
        </v-col>

        <!-- 總體瀏覽 -->
        <TotalReport id="totalReport" @addChartInfo="addChart" :chartInfoState="chartInfoState" :cardInfoItem="cardInfoItem"/>

        <div id="totalReportPageViews" style="display:none"/>
        <div id="totalReportUniqueVisitors" style="display:none"/>
        <div id="totalReportAvgPageViews" style="display:none"/>
        <div id="totalReportAvgPageTime" style="display:none"/>

        <!-- 總體客群 -->
        <!-- <CustomBase id="customBase" @goto="scrollToTarget" /> -->

        <!-- 興趣 -->
        <!-- <InterestTab id="interestTab" @goto="scrollToTarget" /> -->

        <!-- 母體標籤 -->
        <!-- <PopulationTag id="populationTag" /> -->
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

import { mapGetters } from "vuex";
export default {
  components: {

    OverviewFilter: () => import("@/components/overview/OverviewFilter.vue"),
    CardInfo: () => import("@/components/overview/CardInfo.vue"),
    TotalReport: () => import("@/components/overview/TotalReport.vue"),

  },
  computed: {
    ...mapGetters("overview", ["getDateRange"]),
  },
  methods: {
    scrollToTarget(value) {
      this.$vuetify.goTo(value);
    },
    changeChartInfoState(value) {
      this.chartInfoState = value;
      if (value === false) {
        this.chartInfo = [];
      }
    },
    addChart(value) {
      this.chartInfo.push(Object.assign(value));
    },
  },
  data: () => ({
    chartInfo: [],
    chartInfoState: false,
    cardInfoItem: [
      {
        title: "網頁瀏覽數",
        value: "browsingCount",
        icon: "mdi-chart-bar",
        decimals: 0,
        color: "#ffc000",
        helpIconAnnotation: "網頁的瀏覽數加總。重複瀏覽同一個網頁也計算在內",
        helpIconEnabled: true,
      },
      {
        title: "不重複瀏覽人數",
        value: "distinctCount",
        icon: "mdi-chart-line",
        decimals: 0,
        color: "#66bb6a",
        helpIconAnnotation: "每日的不重複瀏覽人數加總",
        helpIconEnabled: true,
      },
      {
        title: "平均瀏覽數",
        value: "averageCount",
        icon: "mdi-chart-areaspline",
        decimals: 2,
        color: "#ed7d31",
        helpIconAnnotation: "網頁瀏覽數/不重複瀏覽人數",
        helpIconEnabled: true,
      },
      {
        title: "平均網頁停留時間",
        value: "averageStaytime",
        icon: "mdi-clock-time-ten-outline",
        decimals: 2,
        color: "#a5a5a5",
        helpIconAnnotation: "平均每位使用者在該網頁上停留多少時間，時間單位為秒",
        helpIconEnabled: true,
      },
    ],
  }),
};
</script>
